export default function ({ startTime, endTime }) {
  // let secsNow = new Date('2 May, 2026 07:25:00') / 1000; // only for testing
  
  let secsNow = Date.now() / 1000;
  

  // if the current time is not within the broadcast
  if (startTime >= secsNow || endTime <= secsNow) {
 
    //Max: NOT SURE why exactly it should be like this... I believe this functionality was added by Luke early on.
    // instead, we will just return startTime (so that counters=0) whenever the broadcast is not happening
    return startTime;

    // // if within 5 hours of start, make counters 0
    // if (secsNow > (startTime - 43200) && secsNow < startTime) {
    //   return startTime;
    // }
    // // if within 200 days after the end time, make counters at end
    // if (secsNow < (endTime + (86400 * 200)) && secsNow > startTime) {
    //   return endTime;
    // }
  
    // // pretend the broadcast is happening based on time of day in UTC
    // const newStartTime = new Date(startTime * 1000);
    // const timeNow = new Date();
    // newStartTime.setUTCHours(timeNow.getUTCHours());
    // newStartTime.setUTCMinutes(timeNow.getUTCMinutes());
    // newStartTime.setUTCSeconds(timeNow.getUTCSeconds());
    // let fakeNowTime = newStartTime.getTime() / 1000;
    // if (fakeNowTime < startTime) {
    //   fakeNowTime += 86400; // add a day on if it's before 5am on Sat
    // }
    // secsNow = fakeNowTime;
  }
  // return 1714881604;
  return Math.round(secsNow);
}



// WEBPACK FOOTER //
// ./src/util/sc_time.js